<lc-base-dialog id="upload-status-dialog" primaryAction="OK" title="Upload Status" (actionClicked)="onClose()">
  <ng-template #content>
    <div class="fx-column fx-gap-sm">
      @if (data.isMultiple) {
        <ul>
          <li class="border border-round p-3 d-flex justify-content-between align-items-center"><b>Successful uploads</b>
          <span id="successful-uploads">{{ data.successfulUploads?.length }}</span>
        </li>
        <li class="border border-round p-3 d-flex justify-content-between align-items-center"><b>Failed Uploads</b>
        <span id="failed-uploads">{{ data.failedUploads?.length }}</span>
      </li>
    </ul>
  }
  <h6 class="text-danger">Failed upload(s):</h6>
  <ul class="scrollable-menu" id="upload-errors">
    @for (msg of data.failedUploads; track msg) {
      <li class="border border-round p-3">
        <div [innerHTML]="msg"></div>
      </li>
    }
  </ul>
</div>
</ng-template>
</lc-base-dialog>

